module.exports = __webpack_public_path__ + "media/yàak jà doo dtàe mĕe.5856cea3.mp3";